import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const HeaderStyled = styled.header`
  background-color: ${({ theme }): string => theme.colors.backgroundDefault};
  white-space: nowrap;
  margin: 0;
  padding: 5px 0 0;
`;

export const FlexContainerStyled = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 0;

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `}
`;

export const MobileContainerStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  ${({ theme }): string => `
    ${theme.devices.tablet} {
     width: auto;
    }
  `}
`;

/** Row containing searchbar + filter buttons. Left and bottom padding match banner card spacing (4px). */
export const SearchAndFiltersRowStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;
  ${({ theme }): string => `
    ${theme.devices.desktop} {
      flex-wrap: nowrap;
    }
  `}

  /* Tablet and mobile: searchbar + filter buttons in a row */
  @media screen and (max-width: 768px) {
    flex-direction: row;
    flex-wrap: nowrap;
    & > *:first-child {
      flex: 1;
      min-width: 0;
    }
    & > *:not(:first-child) {
      flex: 0 0 auto;
      min-width: 0;
    }
  }

  /* Mobile: pull filter buttons a bit to the left */
  @media screen and (max-width: 425px) {
    & > *:not(:first-child) {
      margin-left: -12px;
    }
  }
`;
export const BtnFlexContainerStyled = styled(FlexContainer)`
  gap: 8px;
  flex-wrap: wrap;
  padding-right: 24px;
  padding-bottom: 4px;

  /* Tablet and mobile: action buttons aligned right */
  @media screen and (max-width: 768px) {
    justify-content: flex-end;
    margin-left: 0;
  }

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      justify-content: space-between;
      flex-wrap: nowrap;
    }
  `}
`;

export const TypographyStyled = styled(Typography)`
  margin-right: 1rem;
`;

export const ButtonStyled = styled(Button)`
  ${({ theme }): string => `
    ${theme.devices.tablet} {
      justify-self: flex-end;
    }
  `}
`;

/** Tablet/mobile: Filter chips in their own row below search+filter buttons. Order 2. */
export const FilterChipsRowStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  padding-left: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;
  order: 2;
  flex-wrap: wrap;
  align-items: center;
`;

/** Tablet: search+filters left, action buttons right, same row. Mobile: column layout. */
export const MobileHeaderRowStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: nowrap;
  padding-left: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;

  /* Tablet: single row - search+filters left, action buttons right */
  @media screen and (min-width: 426px) and (max-width: 768px) {
    flex-direction: row;
    & > *:first-child {
      flex: 1;
      min-width: 0;
    }
    & > *:last-child {
      flex: 0 0 auto;
      margin-left: auto;
    }
  }

  /* Mobile: column - search+filters above, action buttons below */
  @media screen and (max-width: 425px) {
    flex-direction: column;
    align-items: stretch;
    & > *:first-child {
      flex: 1;
      min-width: 0;
    }
    & > *:last-child {
      flex: 0 0 auto;
      align-self: flex-end;
    }
  }

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      flex-direction: row;
      align-items: center;
    }
  `}
`;
